import { render, staticRenderFns } from "./ErrorContent.vue?vue&type=template&id=24ae1174&scoped=true&"
import script from "./ErrorContent.vue?vue&type=script&lang=js&"
export * from "./ErrorContent.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContent.vue?vue&type=style&index=0&id=24ae1174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae1174",
  null
  
)

export default component.exports